<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <p-calendar
    [selectionMode]="props.selectionMode"
    [formControl]="$any(formControl)"
    [formlyAttributes]="field"
    [placeholder]="props.placeholder"
    [appendTo]="props.appendTo ?? 'body'"
    [timeOnly]="true"
    [readonlyInput]="props.readonly"
    [showOnFocus]="!props.readonly"
    hourFormat="12"
    id="field.id"
  ></p-calendar>
</span>
